import { useTenant } from '../../contexts/TenantContext'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  showText?: boolean
  textSize?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeClasses = {
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
  xl: 'w-16 h-16',
}

const textSizeClasses = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg',
}

function useTenantLogo() {
  const tenant = useTenant()
  const square = tenant?.brand?.assets?.logoSquare
  const url = tenant?.assetSlug && square
    ? `/tenants/${tenant.assetSlug}/${square}`
    : '/admin-default-logo.svg'
  // Sprint G: prefer the brand's azərbaycan name; fall through to slug only
  // when the tenant template hasn't been seeded yet.
  const name =
    tenant?.brand?.name?.az ?? tenant?.brand?.name?.en ?? tenant?.slug ?? 'Tenant'
  const tagline =
    tenant?.brand?.tagline?.az ?? tenant?.brand?.tagline?.en ?? ''
  return { url, name, tagline }
}

export function Logo({ size = 'md', showText = true, textSize = 'md', className = '' }: LogoProps) {
  const { url, name, tagline } = useTenantLogo()
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src={url}
        alt={`${name} Logo`}
        className={`${sizeClasses[size]} object-contain`}
      />
      {showText && (
        <div>
          <h2 className={`font-semibold text-gray-900 ${textSizeClasses[textSize]}`}>
            {name}
          </h2>
          {tagline && <p className="text-xs text-gray-500">{tagline}</p>}
        </div>
      )}
    </div>
  )
}

export function LogoIcon({
  size = 'md',
  className = '',
}: {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}) {
  const { url, name } = useTenantLogo()
  return (
    <img
      src={url}
      alt={name}
      className={`${sizeClasses[size]} object-contain ${className}`}
    />
  )
}
